import { useMutation, useQueryClient } from '@tanstack/react-query';
import { queries } from '../../../../../shared/queries';
import { handleError } from '../../../../ui/err/handleError';
import { showSuccessNotification } from '../../../../ui/notification';
import { AxiosError } from 'axios';
import { AxiosCommonError } from '../../../../../shared/types';
import { prodoqApis } from '../../../../../shared/apis/prodoq/apis';

export default function useDeleteRole() {
  const queryClient = useQueryClient();
  return useMutation(prodoqApis.deleteRole, {
    onSuccess: () => {
      showSuccessNotification('삭제 성공', '역할 삭제에 성공하였습니다.');
      queryClient.invalidateQueries({ queryKey: queries.prodoq.roles._def });
    },
    onError: (error: AxiosError<AxiosCommonError>) => {
      handleError(error);
    },
  });
}
